import './App.css';

function App() {
  return (
    <div className="App">
      <header className="header">
        <h1 className="logo">Dev Consultants</h1>
        <p className="tagline">Frontend development services dedicated to <a href="https://www.artd.ai/" target="_blank" rel="noopener noreferrer" className="link-artdai">ARTDAI</a></p>
      </header>
      <main className="main">
        <p className="intro">
          We provide <strong>frontend</strong> technology solutions and development services  for <strong><a href="https://www.artd.ai/" target="_blank" rel="noopener noreferrer" className="link-artdai">ARTDAI</a></strong>, supporting their web applications and user interfaces across the United States.
        </p>
      </main>
      <footer className="footer">
        <span>Dev Consultants</span>
        <span className="separator">·</span>
        <span>Frontend services Provider to <a href="https://www.artd.ai/" target="_blank" rel="noopener noreferrer" className="link-artdai">ARTDAI</a></span>
        <address className="footer-address">
          Prop: Mohan Dev, VPO Miani, Ward No. 2, Hoshiarpur, Punjab 144202
        </address>
      </footer>
    </div>
  );
}

export default App;
